/* eslint-disable */
import React, { useState,useEffect  } from "react";
import { auth, db } from "../../firebase-config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { ref, set, onValue, push, getDatabase } from "firebase/database";//deepa auditlog
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddTechnician.css";
import { useUserAuth } from "../../context/UserAuthContext";//deepa css
import { Button } from "react-bootstrap";//deepa css

//deepa auditlog
// ——— Audit‐log helper ——————————————————————————————
async function logAccountCreation({
  createdBy,
  createdFor,
  createdForRole,
  action,
  browser,
  device,
  ip,
  location,
}) {
  // const logRef = ref(
  //   getDatabase(),
  //   "audit_logs/Authentication/UserManagement/Account_Creation"
  // );

  const logRef = ref(db, "audit_logs/UserManagement/Account_Creation");
  await push(logRef, {
    event_type:       "account_created",
    created_by:       createdBy,
    created_for:      createdFor,
    created_for_role: createdForRole,
    timestamp:        new Date().toISOString(),
    details:          { action, browser, device, ip, location },
  });
}
// ————————————————————————————————————————————————
//deepa end auditlog


const AddTechnician = () => {
  const [fullName, setFullName] = useState("");
  const [role, setRole] = useState("Technician");
  const [Email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { logOut } = useUserAuth();//deepa css

  var adminName1 = localStorage.getItem("adminName");
  // console.log(adminName1)

  const users = ref(db, `superadmin/admins/${adminName1}`);
  onValue(users, (snapshot) => {
    const data = snapshot.val();
    // console.log(data)
  });

  const notifyWarning = () =>
    toast.warn("please enter valid ID/Password Or E-mail already exists", {
      position: "top-center",
    });
  const notifySuccess = () =>
    toast.success("Technician Added Successfully", {
      position: "top-center",
    });
    //deepa auditlog
    const browser = navigator.userAgent;
    const device  = /Mobi|Android/i.test(browser) ? "Mobile" : "Desktop";
    const ip      = "Unknown";      // or call ipapi.co once on mount if you prefer
    const location= "Unknown";
    //deepa endauditlog
    const navigate = useNavigate();


  // *** Added Back Button Fix ***
  useEffect(() => {
    window.history.replaceState(null, null, window.location.href); 
    window.addEventListener("popstate", () => {
      navigate("/Admin", { replace: true }); 
    });

    return () => {
      window.removeEventListener("popstate", () => {}); 
    };
  }, [navigate]);


  const handleSubmit = (e) => {
    e.preventDefault();
    function onRegister() {
     // createUserWithEmailAndPassword(auth, Email, password)
      // .then((userCredential) => {+    // 0) Fire-and-forget: log the fact that an attempt just happened
   logAccountCreation({
      createdBy:      adminName1,
      createdFor:     `${role}-${fullName}`,
      createdForRole: role.toLowerCase(),
      action:         "Technician creation attempted",
      browser,
      device,
      ip,
      location
    }).catch(console.error);

    createUserWithEmailAndPassword(auth, Email, password)

        .then(async (userCredential) => {
          set(
            ref(
              db,
              `superadmin/admins/${adminName1}/technicians/` +
                role +
                "-" +
                fullName
            ),
            {
              Name: fullName,
              Password: password,
              Email: Email,
              Role: role,
              privacyAccepted: false,
            }
          );
//deepa auditlog
            // 2) audit-log success
      await logAccountCreation({
        createdBy:       adminName1,
          createdFor:      `${role}-${fullName}`,
        createdForRole:  role.toLowerCase(),
         action:          "Technician account created by Admin",
          browser, device, ip, location
       });//deepa endauditlog

          notifySuccess();
          e.target.reset();
          setTimeout(function () {
            // navigate("/Admin");
            navigate("/Admin", { replace: true }); 
          }, 2000);
        })

        // .catch((error) => notifyWarning(error));

//deepa auditlog
             .catch(async (error) => {
                 // audit-log failure
              await logAccountCreation({
                createdBy:       adminName1,
                   createdFor:      `${role}-${fullName}`,
                    createdForRole:  role.toLowerCase(),
                    action:          `Technician creation failed: ${error.code}`,
                    browser, device, ip, location
                  });
          
                 notifyWarning(error);
               });

               //deepa end auditlog
    }
    onRegister();
  };

 // deepa css

 const handleLogout = async () => {
  try {
    await logOut();
    // navigate("/");
    navigate("/Admin", { replace: true }); 
  } catch (error) {
    console.log(error.message);
  }
};

  return (
    <>

    <div>

      <h2 className="addtechnicianadmin">Technician Enrollment</h2> 
      <form className="admintechnicianaddForm" onSubmit={handleSubmit}>
        <strong className="adminstrongaddpatient">FULL NAME </strong>
        <input
          className="inputaddadmin"
          type="text"
          placeholder="Enter Full Name"
          onChange={(e) => setFullName(e.target.value)}
          required
        ></input>

        <input
          type="hidden"
          id="role"
          name="role"
          value="Technician"
          onChange={(e) => setRole(e.target.value)}
        />
        <strong className="adminstrongaddpatient">EMAIL</strong>
        <input
          className="inputaddadmin"
          placeholder="Enter Your Email"
          onChange={(e) => setEmail(e.target.value)}
          required
          type="email"
        ></input>
        <strong className="adminstrongaddpatient">PASSWORD </strong>
        <input
          className="inputaddadmin"
          placeholder="Enter Password"
          onChange={(e) => setPassword(e.target.value)}
          required
          type="password"
        ></input>
        <button className="addpatientbtnadmin">Add</button>
        <ToastContainer />
    </form>
    </div>
    </>
  );
};

export default AddTechnician;
